import { Component, Inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
  MatDialogContent,
  MatDialogActions
} from '@angular/material/dialog';
import { HireItemService } from '../..';
import { Item, Product } from '../../../models';
import { ItemDialogComponent } from '../item-dialog/item-dialog.component';
import { LocationNameFromIdPipe } from '../../pipes/location-name-from-id.pipe';
import { RouterLink } from '@angular/router';
import { MatButton } from '@angular/material/button';
import { NgFor, NgIf, AsyncPipe } from '@angular/common';
import { FlexModule } from '@angular/flex-layout';

@Component({
  selector: 'add-item-dialog',
  templateUrl: './add-item-dialog.component.html',
  styleUrls: ['./add-item-dialog.component.css'],
  providers: [HireItemService],
  standalone: true,
  imports: [
    MatDialogContent,
    FlexModule,
    NgFor,
    NgIf,
    MatButton,
    RouterLink,
    MatDialogActions,
    AsyncPipe,
    LocationNameFromIdPipe
  ]
})
export class AddItemDialogComponent {
  selectedProduct: Product;
  docketId: number;
  unavailableItem: Item;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    private dialog: MatDialog,
    private mdDialogRef: MatDialogRef<AddItemDialogComponent>
  ) {
    this.selectedProduct = data.product;
  }

  close() {
    this.mdDialogRef.close([]);
  }

  private addToDocket(item) {
    this.mdDialogRef.close({
      item
    });
  }

  openItemDialog(item) {
    this.dialog.open(ItemDialogComponent, {
      data: {
        item
      }
    });
  }

  selectItem(item) {
    if (item.status !== 'Available') {
      this.unavailableItem = item;
      return;
    }
    this.unavailableItem = null;
    this.addToDocket(item);
  }
}
